export enum ColorFamilyGroupNames {
  MostPopular = 'Most Popular',
  LightColors = 'Light',
  MidtoneColors = 'Midtone',
  DarkColors = 'Dark',
}
